import React from 'react';

import { Stack, Typography } from '@mui/material';

import { useCurrentTemplateType } from '../../hooks';

import BasicLayoutPropertiesInput from './BasicLayoutPropertiesInput';
import LayoutSelectorInput from './LayoutSelectorInput';

export default function StylesSidebar() {
  const type = useCurrentTemplateType();
  if (type === 'LAYOUT') {
    return (
      <Stack p={3}>
        <Typography variant="overline" paragraph color="text.secondary">
          Layout styles
        </Typography>

        <BasicLayoutPropertiesInput />
      </Stack>
    );
  }
  return (
    <Stack p={3}>
      <Typography variant="overline" paragraph>
        Template styles
      </Typography>
      <LayoutSelectorInput />
    </Stack>
  );
}
